import { InjectionToken } from '@angular/core';
import { IRedocOauth2Config } from '@redocco/oauth2-redoc-connect';

export const REDOC_OAUTH2_CONFIG = new InjectionToken<IRedocOauth2Config>('REDOC_OAUTH2_CONFIG');
export const REDOC_BASE_URL = new InjectionToken<string>('REDOC_BASE_URL');
